export type ParsedEDocumentStatusPayload = {
  status?: string;
  message?: string;
};

export function parseEDocumentStatusPayload(
  payload: string | null | undefined
): ParsedEDocumentStatusPayload | null {
  if (!payload) {
    return null;
  }
  try {
    const obj = JSON.parse(payload) as unknown;
    if (typeof obj !== "object" || obj === null) {
      return null;
    }
    const record = obj as Record<string, unknown>;
    return {
      status: typeof record.status === "string" ? record.status : undefined,
      message: typeof record.message === "string" ? record.message : undefined,
    };
  } catch {
    return null;
  }
}

export function isEDocumentAtvAccepted(payload: string | null | undefined): boolean {
  const parsed = parseEDocumentStatusPayload(payload);
  return parsed?.status === "aceptado";
}

/** Estado ATV efectivo de un documento electronico. */
export type EDocumentAtvStatus = "pendiente" | "aceptado" | "rechazado";

/**
 * Traduce el payload de Hacienda al estado ATV del documento. Sin payload, con
 * JSON invalido o con un status intermedio ("pending", "procesando") todavia no
 * hay respuesta: el documento queda "pendiente".
 * Mantener alineado con resolveAtvStatus de amplify/functions/searchable/edocuments.ts.
 */
export function resolveEDocumentAtvStatus(
  payload: string | null | undefined
): EDocumentAtvStatus {
  const status = parseEDocumentStatusPayload(payload)?.status;
  if (status === "aceptado" || status === "rechazado") {
    return status;
  }
  return "pendiente";
}

/**
 * El ATV todavia no resolvio el documento. Mientras sea true no se puede anular
 * ni crear notas sobre el, porque su destino final aun se desconoce.
 */
export function isEDocumentAtvPending(payload: string | null | undefined): boolean {
  return resolveEDocumentAtvStatus(payload) === "pendiente";
}
